var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MIcon',{staticClass:"mx-1",attrs:{"name":(_vm.iconMap[_vm.moduleName] || {}).name || 'tire-rugged',"size":"2x"}})}
var staticRenderFns = []

export { render, staticRenderFns }